import { Injectable, inject } from "@angular/core";
import { Route, Router, UrlSegment } from "@angular/router";
import { logout } from "../common/auth";
import { logInfo } from "../common/logger";
import { SessionService } from "src/app/services/session.service";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { sntNavigate } from "src/app/support/router";

@Injectable()
export class SignoutGuard {
  private readonly bootstrapService = inject(BootstrapService);
  private readonly sessionService = inject(SessionService);
  private readonly router = inject(Router);

  async canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> {
    const member = this.bootstrapService.getCurrentMember();
    await logout(member!, this.sessionService);

    logInfo("signout");

    sntNavigate(this.router, ["/auth"]);

    return false;
  }
}
